import { render, staticRenderFns } from "./Nft.vue?vue&type=template&id=47dd2bf9&scoped=true&"
import script from "./Nft.vue?vue&type=script&lang=js&"
export * from "./Nft.vue?vue&type=script&lang=js&"
import style0 from "./Nft.vue?vue&type=style&index=0&id=47dd2bf9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dd2bf9",
  null
  
)

export default component.exports